import React from "react";
import ProjectCard from "./ProjectCard";
import config from "../../script/config";
import  "../../css/style.css"


const Home = () => {
  return (
    <div className="container py-5 white">
      <section
        className="mb-5 d-flex flex-column justify-content-center align-items-center text-center"
        style={{ minHeight: "300px" }}
      >
        <p className="text-primary fw-semibold mb-2 title-md">Hi, my name is</p>
        <h1 className="heading">Sumit Kumar</h1>
        <h2 className="subheading text-muted mb-4 fw-normal">
          I build things for the web.
        </h2>
        <p className="text-muted intro-text">
          I'm a <strong>React Developer</strong> with experience building modern
          web applications. I also work with <strong>DevOps</strong> tools,{" "}
          <strong>Python</strong> for scripting and backend, and{" "} sometimes
          <strong> Unity / C#</strong> for game development.
        </p>
      </section>

      {/* Projects Section */}
      <section className="mb-5 d-flex flex-column justify-content-center align-items-center text-center">
        <h3
          className="text-start pb-2 mb-4"
          style={{
            fontSize: "1.75rem",
            borderBottom: "1px solid #233554",
            color: "#100144",
          }}
        >
          Some Things I’ve Built
        </h3>
        <div className="d-flex flex-column gap-4">
          {config.projects.map((project, index) => (
            <div
              key={index}
              className="mx-auto"
              style={{ maxWidth: "800px", width: "100%" , height:"100%"}}
            >
              <ProjectCard
                title={project.title}
                tech={project.tech}
                description={project.description}
                codeUrl={project.codeUrl}
                liveUrl={project.liveUrl}
              />
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Home;
